<template>
    <div class="guest-wrapper register-wrapper">
        <div class="guest-logo">
            <img src="/images/new_logo_v2.png" width="220"/>
        </div>
        <div class="row">
            <div class="card card-white mt-5">
                <div class="card-header">
                    <h3 class="col-md-12 card-title text-center">Unsubscribe Emails and Notifications </h3>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <h4>Are you sure?</h4>
                            <p>By unsubscribing, you will no longer receives any E-Mails from Capsphere, you can re-enable email subscriptions in your profile settings in the future.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 text-center mt-5">
                            <button class="btn btn-success btn-block" v-on:click.prevent="unsubscribe()">
                                Unsubscribe
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 text-center sm mt-3">
                            <router-link replace to="login">Login here</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Unsubscribe",
        methods: {
          unsubscribe () {
              if(this.$route.query.email) {
                axios.post('/api/unsubscribe_emails/', {
                  email:  this.$route.query.email,
                  email_opt_in: 0
                })
                .then((response) => {
                  this.$noty.success('Successfully unsubscribed.')
                  this.$router.push('/login');
                })
                .catch ((error) => {
                    this.$noty.error('Error! Please try again!')
                })
              }
          }
        }
    }
</script>
